import React from 'react';
import IconContainer from './icon_container';

/**
 * @visibleName Default Avatar
 */

export default function DefaultAvatar(props) {
  return (
    <IconContainer viewBox="0 0 88 88" {...props}>
      <g fill="none" fillRule="evenodd" id="default-avatar" stroke="none" strokeWidth="2">
        <g fillRule="nonzero" id="Shape" transform="translate(1.000000, 1.000000)">
          <path
            d="M19.7,67.9 C30.6,63.8 30.9,70 34.3,58.7 C34.8,57.2 34.4,55.6 33.4,54.5 C32.2,53.2 30.8,51.3 30.4,49.4 C30.3,48.9 30,48.4 29.7,48 C28.7,46.5 26.8,43.2 28.4,40.7 C28.9,40 29,39.1 29,38.2 C28.7,34.5 29,25.5 37.1,22.4 C47.6,18.3 53,25 53,25 C53,25 57.3,28 56.2,38.4 C56.1,39.2 56.3,40 56.6,40.8 C57.2,42.1 57.7,44.4 55.5,47 C55.1,47.5 54.9,48 54.7,48.6 C54.3,50.1 53.5,53.1 51.9,54.8 C51.2,55.6 50.8,56.5 50.8,57.5 C50.8,60.3 51.6,65.6 57,66.2 C62,66.8 69,67 73.1,73.5 C81.1,65.8 86,55 86,43 C86,19.3 66.7,0 43,0 C19.3,0 0,19.3 0,43 C0,54.9 4.8,65.7 12.7,73.5 C14.2,71.2 16.4,69.1 19.7,67.9 Z"
            fill="#CDCCCC"
          />
          <path
            d="M73.2,73.6 C69.1,67 62.1,66.9 57.1,66.3 C51.7,65.6 50.9,60.4 50.9,57.6 C50.9,56.6 51.3,55.6 52,54.9 C53.5,53.1 54.4,50.2 54.8,48.7 C54.9,48.1 55.2,47.5 55.6,47.1 C57.7,44.6 57.2,42.2 56.7,40.9 C56.4,40.2 56.2,39.3 56.3,38.5 C57.3,28 53,25 53,25 C53,25 47.5,18.4 37.2,22.3 C29.1,25.4 28.8,34.4 29.1,38.1 C29.2,39 29,39.9 28.5,40.6 C26.8,43.2 28.7,46.5 29.8,47.9 C30.1,48.3 30.4,48.8 30.5,49.3 C30.9,51.2 32.3,53.1 33.5,54.4 C34.5,55.5 34.9,57.1 34.4,58.6 C30.9,69.9 30.7,63.6 19.8,67.8 C16.5,69 14.3,71.1 12.8,73.4 C20.4,81.2 31.2,86 43,86 C54.8,86 65.4,81.3 73.2,73.6 Z"
            fill="#FFFFFF"
          />
        </g>
        <circle cx="44" cy="45" id="Oval" r="42" stroke="#CDCCCC" />
      </g>
    </IconContainer>
  );
}
